<script>

	import Vue from 'vue';
	import { mapState, mapActions } from 'vuex';

	import './style.scss'

	export default {
		name: 'ModalBox',
		data() {
			return {
				component: null,
			};
		},
		computed: {
			...mapState({
				'modalVisible': state => state.user.modalVisible,
				'modalComponent': state => state.user.modalComponent,
			}),
		},
		methods: {
			...mapActions(['hideModal']),
		},
		watch: {
			modalComponent(componentName) {
				if (!componentName) return;
				Vue.component(componentName, () => import(`../Modals/${componentName}.vue`));
				this.component = componentName;
			},
		},
	};

</script>

<template>
	<div class='modal-box' @keydown.esc='hideModal'>
		<transition
			name='modalbox-transition'
			enter-active-class='animated fadeIn'
			leave-active-class='animated fadeOut'
		>
			<div class='modal-box-overlay' v-if='modalVisible'></div>
		</transition>
		<transition
			name='modalbox-transition'
			enter-active-class='animated fadeInUp'
			leave-active-class='animated fadeOutDown'
		>
			<div class='modal-box-content' v-if='modalVisible' @click.self='hideModal'>
				<div class='modal-box-inner-content'>
					<component :is='component'></component>
				</div>
			</div>
		</transition>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/ModalBox/ModalBox.vue